import {createContext} from 'react'

export const UserManagementContext = createContext()